import { removeElement, bringToFront, bringForward, sendToBack, sendBackward } from './designer-tools.utils';
import { DesignerToolNames } from './designer.enum';

export const RemoveTool = {
  name: DesignerToolNames.Remove,
  icon: 'trash',
  tooltip: 'Remove',
  action: removeElement,
}

export const BringToFrontTool = {
  name: DesignerToolNames.BringToFront,
  icon: 'bring-to-front',
  tooltip: 'Bring to front',
  action: bringToFront,
}

export const BringForwardTool = {
  name: DesignerToolNames.BringForward,
  icon: 'bring-forward',
  tooltip: 'Bring forward',
  action: bringForward,
}

export const SendToBackTool = {
  name: DesignerToolNames.SendToBack,
  icon: 'send-to-back',
  tooltip: 'Send to back',
  action: sendToBack,
}

export const SendBackwardTool = {
  name: DesignerToolNames.SendBackward,
  icon: 'send-backward',
  tooltip: 'Send backward',
  action: sendBackward,
}
